import { render, staticRenderFns } from "./PerfisUsuario.vue?vue&type=template&id=63a9fced&scoped=true&"
import script from "./PerfisUsuario.vue?vue&type=script&lang=js&"
export * from "./PerfisUsuario.vue?vue&type=script&lang=js&"
import style0 from "./PerfisUsuario.vue?vue&type=style&index=0&id=63a9fced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9fced",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
